import 'slick';

( function ( $ ) {
	'use strict';

	const $accordion = $( '.feature-accordion__item-title' );

	$accordion.on( 'click', function () {
		const $this = $( this );
		const $panel = $this.parent().find( '.feature-accordion__item-panel' );
		$this.parent().toggleClass( 'accordion-open' );
		$panel.slideToggle( '300' );
	} );

} )( jQuery );

